import React from 'react';
import {Link} from 'react-router-dom'

import Banner from '../App/Banner';

import Check from '../../assets/check.svg'
import GreyArrow from '../../assets/grey arrow.svg'

function HorsUE() {
  return(
    <div>
      <Banner />
      <div className='paper'>
      <Link to='/'>
          <button className="return">
          <img src={GreyArrow} alt="fleche grise"/>
            Retour
          </button>
      </Link>

      <div className='breadcrumbs'>
          <p><img src={Check} />Votre stock se situe hors Union Européenne</p>
      </div>

        <h2>La valeur de la marchandise est :</h2>      
        <div className="select_container">
          <Link to='/MarketPlace'><button className='select'>inférieure à 150 €</button></Link>
          <Link to='/DropShippingUE'><button className='select'>supérieure à 150 €</button></Link>
        </div>

      </div>
    </div>
  )
}

export default HorsUE